/**
 * Created by Ivan on 27.07.2026
 */

const EnergyBoosterWindow = Prefab.createWindow(
    "energy_booster_window",
    "energy_booster_window_prefab_json"
);
